import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/StyleMenuHome.css";
import { Icon } from "@mui/material";

export default function MenuAlat() {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [userJabatan, setUserJabatan] = useState("");

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            setUserName(userData.nama || "");
            setUserJabatan(userData.jabatan || "");
        }
    }, []);

    const handleChecklistDronePress = async () => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            const access = userData.menu_access;

            if (access === "drone") {
                navigate("/menu-drone-checklist");
            } else {
                navigate("/form-checklist-drone");
            }
        } else {
            console.error(
                "Data pengguna tidak ditemukan, tidak dapat menentukan akses menu."
            );

            navigate("/form-checklist-drone");
        }
    };

    return (
        <div className="menu-home-container" style={{ width: "100%" }}>
            <header className="app-header">
                <div className="header-content">
                    <button className="back-button" onClick={() => navigate("/menu")}>
                        <Icon>arrow_back</Icon>
                    </button>
                    <h1 className="header-title"> Laporan Alat</h1>
                    <div className="header-spacer"></div>
                </div>
            </header>
            <div className="menu-home-content">

                <div className="menu-grid">
                    <div className="menu-item" onClick={handleChecklistDronePress}>
                        <button className="menu-button">
                            <span className="mdi mdi-quadcopter menu-icon"></span>
                        </button>
                        <div className="menu-text">Check List Drone</div>
                    </div>

                    <div
                        className="menu-item"
                        onClick={() => navigate("/form-laporan-kerusakan")}
                    >
                        <button className="menu-button">
                            <span className="mdi mdi-clipboard-alert-outline menu-icon"></span>
                        </button>
                        <div className="menu-text">Laporan Kerusakan</div>
                    </div>
                </div>


            </div>
        </div>
    );
}
